package com.macrofocus.eflux.ui.data

import com.macrofocus.common.selection.MutableSelection
import com.macrofocus.common.selection.MutableSingleSelection
import com.macrofocus.eflux.DataLoader
import com.macrofocus.eflux.network.coordinate.Coordinate
import mui.material.*
import mui.material.styles.Theme
import mui.material.styles.useTheme
import mui.system.sx
import org.mkui.color.MkColor
import org.mkui.color.toKotlinJS
import org.mkui.react.useProperty
import org.mkui.react.useSelection
import org.mkui.react.useSingleSelection
import react.FC
import react.Props
import react.ReactNode
import react.dom.html.ReactHTML.span
import react.useRef
import web.cssom.FontFamily
import web.cssom.FontSize
import web.cssom.None
import web.cssom.WhiteSpace
import web.timers.Timeout
import web.timers.clearTimeout
import web.timers.setTimeout
import kotlin.time.Duration.Companion.milliseconds

external interface CoordinateButtonProps : Props {
    var dataLoader: DataLoader
    var primary: Boolean?
    var probing: MutableSingleSelection<Coordinate>
    var selection: MutableSelection<Coordinate>
    var coordinate: Coordinate?
    var filled: Boolean?
}

val CoordinateButton = FC<CoordinateButtonProps> { props ->
    val outlined = true
    val theme = useTheme<Theme>()

    val dataLoader = props.dataLoader
    val controller = dataLoader.controller

    val (network, _) = useProperty(dataLoader.substationNetwork)
    val coordinate = props.coordinate
    val serif = false

    val (probed, _) = useSingleSelection(props.dataLoader.controller.coordinateProbing)
    val (selected, _) = useSelection(props.dataLoader.controller.coordinateSelection)

    val clickTimer = useRef<Timeout>(null)

    if(coordinate != null) {
        val seq = coordinate.seq
        val longitude = coordinate.physicalGeometry?.x
        val latitude = coordinate.physicalGeometry?.y

        Tooltip {
            if(coordinate.risk_map != null && coordinate.risk_map > 0) {
                title = ReactNode("${coordinate.risk_list} #$seq $latitude,$longitude")
            } else {
                title = ReactNode("$latitude,$longitude")
            }
            placement = TooltipPlacement.left

            Badge {
//                if(props.risks == true && line.assetCount != null) {
//                    badgeContent = ReactNode(line.assetCount.toString())
//                    color = if (line.probability != null) {
//                        if (line.probability >= 0.1) BadgeColor.error
//                        else if (line.probability >= 0.05) BadgeColor.warning
//                        else if (line.probability > 0.0) BadgeColor.info
//                        else BadgeColor.default
//                    } else BadgeColor.default
//                }

                Button {
                    sx {
                        if(false) {
                            textTransform = None.none
                        } else {
                            fontFamily = "'JetBrains Mono', monospace".unsafeCast<FontFamily>()
                            fontSize = FontSize.xSmall
                        }
                        if(!outlined) {
//                            backgroundColor = dataLoader.getColor(line, theme).toKotlinJS()
//                            "&:hover" {
//                                backgroundColor = dataLoader.getColor(line, theme).brighter().toKotlinJS()
//                            }
                        } else {
                            if(!(props.filled == false)) {
                                backgroundColor = (theme.asDynamic().substationFillColor as MkColor).toKotlinJS()
                            }
//                            borderColor = dataLoader.getColor(line, theme).toKotlinJS()
//                            "&:hover" {
//                                borderColor = dataLoader.getColor(line, theme).brighter().toKotlinJS()
//                            }
                        }
                    }
                    color = if (coordinate.probability != null) {
                        if (coordinate.probability >= 0.1) ButtonColor.error
                        else if (coordinate.probability >= 0.05) ButtonColor.warning
                        else if (coordinate.probability > 0.0) ButtonColor.info
                        else ButtonColor.primary
                    } else ButtonColor.primary

                    variant = ButtonVariant.outlined
                    size = Size.small
                    onPointerEnter = {
                        if(props.primary != null) controller.probeCoordinate(coordinate, props.primary!!)
                    }
                    onPointerLeave = {
                        if(props.primary != null) controller.probeCoordinate(null, props.primary!!)
                    }
                    onClick = {
                        // cancel previous timer
                        clickTimer.current?.let {
                            clearTimeout(it)
                        }

                        // start new one
                        clickTimer.current = setTimeout(250.milliseconds)  {
                            dataLoader.overviewZoom(coordinate.logicalGeometry, coordinate.physicalGeometry)
                            if(props.primary != null) controller.selectCoordinate(coordinate, props.primary!!)
                        }
                    }
                    onDoubleClick = {
                        // cancel pending single click
                        clickTimer.current?.let { clearTimeout(it) }

                        dataLoader.physicalZoom(coordinate.physicalGeometry)
                        if(props.primary != null) controller.selectCoordinate(coordinate, props.primary!!)
                    }
                    Box {
                        component = span
                        sx {
//                            display = Display.inlineBlock
//                            overflow = Overflow.hidden
//                            textOverflow = TextOverflow.ellipsis
                            whiteSpace = WhiteSpace.nowrap
//                            maxWidth = 100.pct
                        }
                        +"${longitude}, ${latitude}"
                    }
                }
            }
        }
    }
}